var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#05BC86"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_536_3861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5381 33.9819L29.2724 42.2477L31.4314 44.4067L36.0115 39.8267V54.9955H39.0648V39.8267L43.6449 44.4067L45.8039 42.2477L37.5381 33.9819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.747 33.3588C49.5664 26.6965 44.0906 21.332 37.3855 21.332C34.3052 21.332 31.3539 22.4716 29.0751 24.5407C27.1115 26.3235 25.7847 28.6675 25.2652 31.2353C23.4089 31.6344 21.7146 32.5946 20.4037 34.0078C18.8023 35.7345 17.9203 37.983 17.9203 40.3391C17.9203 45.4742 22.098 49.6518 27.2331 49.6518C27.2452 49.6518 27.2572 49.6517 27.266 49.6515H28.8361V46.5982H27.2534L27.2244 46.5985C23.777 46.5938 20.9737 43.7877 20.9737 40.3391C20.9737 37.0989 23.5 34.3585 26.7251 34.1003L27.9923 33.9989L28.1221 32.7344C28.6105 27.9747 32.5929 24.3853 37.3855 24.3853C42.5206 24.3853 46.6982 28.563 46.6982 33.698V36.3697H48.9119C51.732 36.3697 54.0262 38.664 54.0262 41.4841C54.0262 44.3042 51.732 46.5984 48.9119 46.5984L46.2402 46.5979V49.6514H48.8622C48.8788 49.6517 48.8953 49.6519 48.9119 49.6519C53.4156 49.6519 57.0796 45.9879 57.0796 41.4842C57.0796 37.2622 53.8601 33.7783 49.747 33.3588Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_536_3861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1593,
    height: 39.1593,
    fill: "white",
    transform: "translate(17.9203 18.584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7b7c36d1519923a6e6001e29d11f331c.svg";
export { ForwardRef as ReactComponent };